import React from "react";
import {
    TextField,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Button,
    Divider,
} from "@material-ui/core";
import { useStyles, StyledTableCell } from "../../adminStyles";

const ContractorList = ({
    data,
    searchTerm,
    onUpdateBilling_Cost,
    bindBilling,
    saveRecords,
    employeeType,
}) => {
    const { tableRoot, tableContainer } = useStyles();

    return (
        <Paper className={tableRoot}>
            <TableContainer className={tableContainer}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="center">
                                Name
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                Vendor
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                Project
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                Billing Rate
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                Cost To Company
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data
                            .filter(row =>
                                row.name
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                            )
                            .map((row, k) => (
                                <>
                                    <TableRow key={k}>
                                        <TableCell
                                            align="center"
                                            rowSpan={
                                                (row.projects || []).length > 0
                                                    ? row.projects.length + 1
                                                    : 2
                                            }
                                        >
                                            {row.name}
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            rowSpan={
                                                (row.projects || []).length > 0
                                                    ? row.projects.length + 1
                                                    : 2
                                            }
                                        >
                                            {row.vendorName}
                                        </TableCell>
                                    </TableRow>
                                    {(row.projects || []).length > 0 ? (
                                        row.projects.map((project, i) => {
                                            return (
                                                <TableRow key={k + "=" + i}>
                                                    <TableCell align="center">
                                                        {project.projectName}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField
                                                            variant="outlined"
                                                            id="txtBillingRate"
                                                            type="number"
                                                            name="billingRate"
                                                            label="Billing Rate"
                                                            inputProps={{
                                                                style: {
                                                                    textAlign:
                                                                        "center",
                                                                },
                                                            }}
                                                            value={
                                                                project.billingRate ||
                                                                ""
                                                            }
                                                            onChange={e => {
                                                                let _projects = row.projects.slice();
                                                                _projects[i][
                                                                    e.target.name
                                                                ] =
                                                                    e.target.value;
                                                                onUpdateBilling_Cost(
                                                                    k,
                                                                    _projects
                                                                );
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField
                                                            id="txtCostCompany"
                                                            variant="outlined"
                                                            type="number"
                                                            name="costToCompany"
                                                            label="Cost to company"
                                                            value={
                                                                project.costToCompany ||
                                                                ""
                                                            }
                                                            onChange={e => {
                                                                let _projects = row.projects.slice();
                                                                _projects[i][
                                                                    e.target.name
                                                                ] =
                                                                    e.target.value;
                                                                onUpdateBilling_Cost(
                                                                    k,
                                                                    _projects
                                                                );
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    textAlign:
                                                                        "center",
                                                                },
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })
                                    ) : (
                                        <TableRow key={k + "=" + 0}>
                                            <TableCell align="center">
                                                {""}
                                            </TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    )}
                                </>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Divider />
            <TableRow
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    padding: 10,
                }}
            >
                <div>
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            marginRight: "10px",
                        }}
                        onClick={e => {
                            bindBilling();
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={e => {
                            saveRecords(e, employeeType.Contractor);
                        }}
                    >
                        Save
                    </Button>
                </div>
            </TableRow>
        </Paper>
    );
};
export default ContractorList;
